<script>
import options from './NewCarLoanCalculatorInputs.options'
export default options
</script>

<template>
    <article class="nyk-new-car-loan-calculator-inputs">
        <GenericInput
            type="text"
            inputName="carPrice"
            v-model="carPrice"
            :modelValue="carPrice"
            :isRequired="true"
            :isValid="carPriceValidation()"
            :isValidationError="displayErrors && !carPriceValidation()"
            :label="labelsInput.carPrice"
            :errorMessageLabel="carPriceErrorMessage"
            inputmode="numeric"
            :prefix="labelsInput.currencyPrefix"
            v-on:input="carPriceCallback"
            v-on:keyup.enter="submit" />

        <GenericInput
            type="text"
            inputName="downPayment"
            v-model="downPayment"
            :modelValue="downPayment"
            :isRequired="true"
            :isValid="downPaymentValidation()"
            :isValidationError="displayErrors && !downPaymentValidation()"
            :label="labelsInput.downPayment"
            :errorMessageLabel="downPaymentErrorMessage"
            inputmode="numeric"
            :prefix="labelsInput.currencyPrefix"
            v-on:input="downPaymentCallback"
            v-on:keyup.enter="submit" />

        <div class="nyk-form-range">
            <label for="loanTerm" class="nyk-form-range__label nyk-new-car-loan-calculator-form__label">
                {{ labelsInput.loanTerm }} <span>{{ loanTermClamped }} {{ labelsInput.YearUnit }}</span>
            </label>
            <input
                id="loanTerm"
                class="nyk-form-range__input"
                v-model="loanTermClamped"
                type="range"
                :min="optionsInput.minLoanTerm"
                :max="optionsInput.maxLoanTerm" />
        </div>
    </article>
</template>